import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconChevronLargeDown: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-1.5-IconChevronLargeDown"><Path fillRule="evenodd" clipRule="evenodd" d="M2.48878 8.72168L12.0001 14.3771L21.5115 8.72168L22.2781 10.011L12.0001 16.1222L1.72217 10.011L2.48878 8.72168Z" fill="currentColor"/></CentralIconBase>;
});

export default IconChevronLargeDown;
